module.exports = __webpack_public_path__ + "static/media/ic-haux-training.3df5ab15.svg";